import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGetOrganizationsQuery } from '../../services/portal';
import DataGrid from '../../components/Users/InterActiveDatagrid'; 
import { format } from 'date-fns';

const Organizations = () => {
  let navigate = useNavigate();

  const { data: organizations } = useGetOrganizationsQuery({
    forceRefetch: true
  });
  
 
  
  console.log("Organizations data:", organizations);
  
  const handleNewOrganization = () => {
    navigate('/organizations/new');
  };

  const handleEditOrganization = (organizationId) => {
    navigate(`/organizations/${organizationId.organization_id}`);
  };

  const handleDeleteOrganization = (rowData) => {
    // Handle delete organization action
    console.log("Delete organization:", rowData.organization_id);
    
  };
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';
  
    return format(date, 'dd/MM/yyyy HH:mm:ss'); 
  };

  const statusColorsInline = {
    active: { backgroundColor: "#bbf7d0", color: "#166534" }, // Light green
    starting: { backgroundColor: "#bbf7d0", color: "#166534" }, // Light green
    running: { backgroundColor: "#bbf7d0", color: "#166534" }, // Light green
    inactive: { backgroundColor: "#e5e7eb", color: "#374151" }, // Gray
    suspended: { backgroundColor: "#fef08a", color: "#92400e" }, // Yellow
    error: { backgroundColor: "#fecaca", color: "#991b1b" }, // Red
    succeeded: { backgroundColor: "#bbf7d0", color: "#166534" } // Green
  };

const columns = [
    { field: 'organization_name', header: 'Name' },
    { field: 'capacity_Name', header: 'Capacity Name' },
    { field: 'capacity_Timeout', header: 'Timeout (min)' },
    
    { 
      field: 'last_Active_Date', 
      header: 'Last Active Date',
      body: (rowData) => rowData.last_Active_Date 
    },
    { 
      field: 'suspend_Date', 
      header: 'Suspend Date',
      body: (rowData) => rowData.suspend_Date
    },
    { field: 'primary_Contact', header: 'Primary Contact' },
    { field: 'secondary_Contact', header: 'Secondary Contact' }
  ];
  
  
  return (
    <div className="page">
      <div className="page-inner">
        <header className="page-title-bar">
          <div className="d-flex justify-content-between">
            <h1 className="page-title">
              <i className="far fa-building text-muted mr-2"></i>Organizations{' '}
            </h1>
            <div className="btn-toolbar">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleNewOrganization}>
                + New
              </button>
            </div>
          </div>
        </header>

        <div className="page-section">
          <div className="card card-fluid">
            <div className="table-responsive">
              <DataGrid 
                  data={organizations?.organizations} 
                  columns={columns} 
                  onEditRow={handleEditOrganization} 
                   showEditRow={true}
/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Organizations;
